var LGFG = LGFG || {};
LGFG.WF = LGFG.WF || {};

LGFG.WF.DistributorMapFilter = LGFG.WF.DistributorMapFilter || (function () {

    // Define settings defaults
    var _settings = {
        radiusControlSelector: null,
        locationSearchTextBoxSelector: null,
        locationSearchSubmitSelector: null,
        currentLocationSelector: null,
        clearSearchButtonSelector: null
    };

    var _filterData = {
        searchPoint: undefined,
        searchRadius: undefined,
        searchQuery: undefined
    }
    var _getFilterData = function () {
        return _filterData;
    }

    var _mapObject = null

    var _filterChanged = function (mapConfig) { };
    var _filterCleared = function () { };

    function drawRadius() {
        if (typeof (_filterData.searchPoint) !== 'undefined') {

            if (typeof (_mapObject.customcircle) !== 'undefined') {
                _mapObject.customcircle.setMap(null);
            }

            _mapObject.customcircle = new google.maps.Circle({
                strokeColor: '#f99d21',
                strokeOpacity: 0.5,
                strokeWeight: 1,
                fillColor: '#f99d21',
                fillOpacity: 0.2,
                map: _mapObject,
                radius: _filterData.searchRadius,
                center: new google.maps.LatLng(_filterData.searchPoint.lat, _filterData.searchPoint.lng)
            });

            _mapObject.fitBounds(_mapObject.customcircle.getBounds());
        }
    }

    var getBoundsOrViewport = function (geometry) {
        if (typeof (geometry.bounds) !== 'undefined') {
            return geometry.bounds;
        }
        if (typeof (geometry.viewport) !== 'undefined') {
            return geometry.viewport;
        }
    }

    function searchMap() {
        // console.log('searchMap:');
        // console.log(_filterData);
        // console.log(_filterData.searchQuery);
        // console.log(_filterData.searchRadius);
        if (typeof (_filterData.searchQuery) !== 'undefined') {
            $(_settings.locationSearchTextBoxSelector).blur();
            if (typeof (_filterData.searchRadius) === 'undefined') {
                _filterData.searchRadius = parseInt($(_settings.radiusControlSelector).val()) * 1000;
            }
            LGFG.WF.KenticoSettings.get('WFGoogleMapsApiKey', function (value) {
                console.log(value);
                
                const radiusContainer = document.querySelector('.distributor-radius-container');
                radiusContainer.classList.remove('hidden');
				
                $.ajax({
                    url: 'https://maps.googleapis.com/maps/api/geocode/json',
                    data: {
                        address: _filterData.searchQuery,
                        key: value,
                        components: _filterData.components
                    },
                    success: function (result) {
                        // console.log(result);
                        if (result.results.length > 0) {
                            $(_settings.locationSearchTextBoxSelector).val(result.results[0].formatted_address);

                            _filterData.searchPoint = { lat: result.results[0].geometry.location.lat, lng: result.results[0].geometry.location.lng };
                            //;
                            var geometry = result.results[0].geometry;

                            _filterChanged({
                                country: null,
                                center: {
                                    lat: geometry.location.lat,
                                    lng: geometry.location.lng
                                },
                                neBound: {
                                    lat: getBoundsOrViewport(geometry).northeast.lat,
                                    lng: getBoundsOrViewport(geometry).northeast.lng
                                },
                                swBound: {
                                    lat: getBoundsOrViewport(geometry).southwest.lat,
                                    lng: getBoundsOrViewport(geometry).southwest.lng
                                }
                            });

                            if (_settings.radiusControlSelector !== null) {
                                drawRadius();
                            }
                        } else {
                            // todo no results found from geocode service
                        }
                    }
                });
                $(_settings.clearSearchButtonSelector).show();
            });
        }
    }

    var geoLocateSuccess = function (position) {
        console.log('geoLocateSuccess', position);
        _filterData.searchQuery = position.coords.latitude + ',' + position.coords.longitude;
        _filterData.components = '';
        searchMap();
        LGFG.WF.LoadingOverlay.remove('currentlocationselector');
    }

    var geoLocateFailure = function (error) {
        console.log('geoLocateFailure', error);
        switch (error.code) {
        case error.TIMEOUT:
            console.log("Browser geolocation error !\n\nTimeout.");
            break;
        case error.PERMISSION_DENIED:
            console.log("Browser geolocation error !\n\nPermission denied.");
            break;
        case error.POSITION_UNAVAILABLE:
            console.log("Browser geolocation error !\n\nPosition unavailable.");
            break;
        }
        LGFG.WF.KenticoSettings.get('WFGoogleMapsApiKey', function (value) {
            jQuery.post(`https://www.googleapis.com/geolocation/v1/geolocate?key=${value}`, function (success) {
                geoLocateSuccess({ coords: { latitude: success.location.lat, longitude: success.location.lng } });
            }).fail(function (err) {
                console.log("API Geolocation error! \n\n" + err);
                LGFG.WF.LoadingOverlay.remove('currentlocationselector');
            });
        });
    }

    var bindEvents = function () {
        // bind filter events

        // clear search events
        $(_settings.clearSearchButtonSelector).hide();
        $(_settings.clearSearchButtonSelector).click(function (e) {
            e.preventDefault();
            _filterData.searchPoint = undefined;
            _filterData.searchQuery = undefined;
            if (typeof (_mapObject.customcircle) !== 'undefined') {
                _mapObject.customcircle.setMap(null);
            }
            $(_settings.locationSearchTextBoxSelector).val('');
            $(_settings.clearSearchButtonSelector).hide();
            _filterCleared();
        });

        // radiusControlSelector events
        rangeSlider.create($(_settings.radiusControlSelector), {
            onSlide: val => {
                $('output').text(val);
            },
            onSlideEnd: val => {
                _filterData.searchRadius = parseInt(val) * 1000;
                searchMap();
            }
        });

        // text search events
        $(_settings.locationSearchSubmitSelector).click(function (e) {
            e.preventDefault();
            var text = $(_settings.locationSearchTextBoxSelector).val();
            if (window.location.host === "www.waratahfencing.com.au") {

                console.log("Searching Australia...");
                _filterData.searchQuery = text + ', ' + 'Australia';
                _filterData.components = 'country:AU';

            } else if (window.location.host === "www.waratahfencing.co.nz") {

                console.log("Searching New Zealand...");
                _filterData.searchQuery = text + ', ' + 'New Zealand';
                _filterData.components = 'country:NZ';

            } else {

                console.log("Unable to determine culture. Searching Australia...");
                _filterData.searchQuery = text + ', ' + 'Australia';
                _filterData.components = 'country:AU';

            }
            searchMap();
        });

        // geolocation search events
        $(_settings.currentLocationSelector).click(function (e) {
            LGFG.WF.LoadingOverlay.add('currentlocationselector');
            e.preventDefault();
            console.log('clicked current location selector');
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(geoLocateSuccess, geoLocateFailure);
            } else {
                geoLocateFailure('navigator.geolocation is false');
            }
        });

        var initialQuery = $.urlParam('q') || '';
        if (initialQuery.length > 0) {
            $(_settings.locationSearchTextBoxSelector).val(initialQuery);
            $(_settings.locationSearchSubmitSelector).click();
            if ($('#top')) {
                $('html,body').animate({ scrollTop: $('#top').offset().top }, 'slow');
            }
        }
    };

    var init = function (mapObject, settings, filterChanged, filterCleared) {

        if (typeof (mapObject) === 'undefined') {
            alert('map object is not defined');
            throw 'Map object is not defined';
        }

        _mapObject = mapObject;

        // Override settings defaults if specified
        if (typeof (settings) !== 'undefined') {
            _settings = settings;
        }

        if (typeof (filterChanged) !== 'undefined') {
            _filterChanged = filterChanged;
        }

        if (typeof (filterCleared) !== 'undefined') {
            _filterCleared = filterCleared;
        }

        bindEvents();
    };

    return {
        init: init,
        getData: _getFilterData
    };
})();